export enum STATUS_CODE {
  OK = 100,
  DATA_INVALID = 102,
  ERROR = 417,
  INTERNAL_ERROR = 500,
  DATA_INVALID_AMOUNT_NOT_ALLOWED = 511
}
